import Error404 from './components/Error404'

const ErrorsPage = () => (
  <Error404/>
)

export {ErrorsPage}
